let config = {
    AdminKey: "HCC_ADMIN_TOKEN",
    UserIdKey: "HCC_USER_ID_KEY",
    UserEntered: "HCC_USER_HAS_ENTERED",
    UserVoted: "HCC_USER_HAS_VOTED",
};

export default config;
